export default __webpack_public_path__ + "static/media/IMG_0372cropped.23a7c550.jpeg";